module.exports = __webpack_public_path__ + "static/media/1POLICY15.1f6bd7e5.jpg";